import React, { FunctionComponent } from 'react';
import { useTheme } from '@mui/material/styles';
// import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
// import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next'
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../lib/server_helper';
// import { fetch_all, fetch_all_with_count, fetch_one } from "../../../../lib/v31lib";
import { loginAtom } from '../../../../lib/auth';
// import { currentPracticeAtom } from '../../../../lib/practice';

import HelpersClientWidgets from '../../../../actions/helpers/client_widgets';

import {
  Divider,
  Grid,
  Paper,
} from '@mui/material';

import {
  Typography
} from '../../../../components/v2/styled';

import { User } from '../../../../models/User';

// const { DateTime } = require("luxon");

type Props = {
  object: User;
}

export const CoachUserWidgetsNotificationInformation: FunctionComponent<Props> = ({
  object
}) => {
  const [login] = useAtom(loginAtom);
  // const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const theme = useTheme();
  // const navigate = useNavigate();
  const {t} = useTranslation(['translations']);
  // const params = useParams();
  // const queryClient = useQueryClient();
  // const { state } = useLocation();
  // const [searchParams, setSearchParams] = useSearchParams();

  // Coach-level per-notification visibility (which rows to surface). Lives on
  // the *coach's* userdetail_widgets settings, not the client's. Default on —
  // rows render unless the coach explicitly hid them.
  const visibility = login?.settings?.userdetail_widgets?.settings?.notification_information || {};
  // Fixed-order items, each tagged with shown/hidden state.
  const orderedItems = HelpersClientWidgets.getOrderedNotificationItems(visibility);

  // Maps a notification key to the client's saved preference (yes/no value the
  // row reports). The coach setting only gates *whether* the row renders; the
  // value itself is the client's, not the coach's.
  const NOTIFICATION_VALUE: Record<string, boolean> = {
    nutri_appointment: !!object.settings?.notifications?.nutri_appointment,
    nutri_workshop: !!object.settings?.notifications?.nutri_workshop,
  };

  // i18n label keys for the two rows live under client.settings.notifications
  // with a non-snake-cased module segment (nutriappointment / nutriworkshop).
  const ROW_LABEL_KEY: Record<string, string> = {
    nutri_appointment: 'client.settings.notifications.nutriappointment.general',
    nutri_workshop: 'client.settings.notifications.nutriworkshop.general',
  };

  let notificationColour = (bool:boolean) => {
    return <>
      {bool && <Typography sx={{
        color: theme.palette.primary.main
      }}>{t("coach.notifications.option_yes")}</Typography>}
      {!bool && <Typography sx={{
        color: theme.palette.secondary.main
      }}>{t("coach.notifications.option_no")}</Typography>}
    </>
  }

  return <Paper sx={{padding: 2, marginTop: 1}}>
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Typography variant="h5" html>{t("coach.submenu.detail.notification_information")}</Typography>
        <Divider />
      </Grid>
      {orderedItems.map((item) => {
        // Hidden by the coach → row not rendered. The yes/no value still
        // comes from the client's saved preference (NOTIFICATION_VALUE).
        if (item.state === 'hidden') return null;
        return <Grid key={item.key} item xs={12}>
          <Typography variant="subtitle2" html>{t(ROW_LABEL_KEY[item.key])}</Typography>
          {notificationColour(NOTIFICATION_VALUE[item.key])}
        </Grid>;
      })}
    </Grid>
  </Paper>;
}
